var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('section',{staticClass:"PageView"},[_c('PageCover',{attrs:{"item":_vm.data}}),_c('div',{staticClass:"PageContent_section PageContent-light-background"},[_c('ParagraphList',{attrs:{"items":_vm.paragraph}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }